import { formatAgency } from './agency';

/**
 * Where a notice came from. SAM.gov rows carry source "sam" (or none);
 * each state feed has its own id and this is the one place that names it.
 */
export interface SourceInfo {
  /** Short label for pills: the state name. */
  state: string;
  /** The buying system, used where the UI used to say "SAM.gov". */
  system: string;
}

const SOURCES: Record<string, SourceInfo> = {
  fl_vbs: { state: 'Florida', system: 'Vendor Bid System' },
  al_rfp: { state: 'Alabama', system: 'Statewide RFP Database' },
};

export function sourceInfo(source?: string | null): SourceInfo | null {
  return source && SOURCES[source] ? SOURCES[source] : null;
}

/** "SAM.gov" for federal rows, the state system's name otherwise. */
export function sourceSiteName(source?: string | null): string {
  return sourceInfo(source)?.system ?? 'SAM.gov';
}

/**
 * The agency line on a list card. Federal rows show the department, the top
 * tier of SAM's path. State rows show the buying department instead, because
 * the state pill already says which state and "STATE OF FLORIDA" would repeat it.
 */
export function cardAgency(opp: { agency?: string | null; subAgency?: string | null; source?: string | null }): string {
  if (sourceInfo(opp.source)) return opp.subAgency || formatAgency(opp.agency);
  return formatAgency(opp.agency, { levels: 1 });
}
